import { render, staticRenderFns } from "./ProgramBaru.vue?vue&type=template&id=f70e0da4&"
import script from "./ProgramBaru.vue?vue&type=script&lang=js&"
export * from "./ProgramBaru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports